<template>
  <div>
    <section class="sections">
      <TopBanner
        class="mb-16"
        :item="banner"
        v-if="
          banner &&
          Object.keys(banner).length &&
          banner.images.length &&
          currentTranslate &&
          Object.keys(currentTranslate).length
        "
      />

      <div
        :class="{
          '_bg-light':
            formattedElements && formattedElements.length && countElements,
        }"
      >
        <div
          class="container _pt-16 _px-md-4 _px-sm-0"
          v-if="
            getAcademySection !== null && Object.keys(getAcademySection).length
          "
        >
          <AppBtnBreadCrumb
            v-if="
              getAcademySection !== null &&
              Object.keys(getAcademySection).length
            "
            :parent_page="
              getAcademySection.parent_slug ? 'SuccessAcademySections' : ''
            "
            :params="{ slug: getAcademySection.parent_slug }"
          />
        </div>
      </div>
      <div v-if="getAcademySection !== null">
        <div
          class="_bg-light"
          v-if="formattedElements && formattedElements.length && countElements"
        >
          <div class="container _pb-12 _px-md-4 _px-sm-0">
            <div class="d-grid row-1-1 videos gap-32 _pt-6">
              <VideoCard
                @like="like"
                @viewItem="viewItem"
                @favorite="favorite"
                @downloadFile="downloadFile"
                @setVideoProgress="setVideoProgress"
                v-for="block in countElements"
                :key="formattedElements[block - 1].id"
                :item="formattedElements[block - 1]"
                :parentSlug="$route.params.slug"
                :analyticEventPrefix="'academy_material'"
              >
              </VideoCard>
            </div>
            <div
              class="btn btn_secondary more-btn _mt-6 _br--0"
              @click="loadMore"
              v-if="
                formattedElements &&
                formattedElements.length &&
                formattedElements.length > countElements
              "
            >
              <div class="more-btn__text _py-6 d-flex align-center">
                <svg
                  class="_mr-2"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5 8V12M12.5 16H12.51M22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12Z"
                    stroke="#629727"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                {{ $t("interface.load_more") }}
              </div>
            </div>
          </div>
          <div
            class="container _pb-12"
            v-if="currentTranslate.links && currentTranslate.links.length"
          >
            <div class="additional-links _px-md-4">
              <div class="other-head__container _mb-6">
                <div class="other-carousel__nav" v-if="showNav">
                  <div @click="showPrev" class="other-carousel__nav-prev _mr-4">
                    <svg
                      width="38"
                      height="38"
                      viewBox="0 0 38 38"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="38" height="38" rx="16" fill="#D1D2CD" />
                      <path
                        d="M26 19H12M12 19L19 26M12 19L19 12"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <div @click="showNext" class="other-carousel__nav-next">
                    <svg
                      width="38"
                      height="38"
                      viewBox="0 0 38 38"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="38" height="38" rx="16" fill="#D1D2CD" />
                      <path
                        d="M12 19H26M26 19L19 12M26 19L19 26"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <VueSlickCarousel v-bind="settings" ref="materialsCards">
                <MaterialCard
                  v-for="i in currentTranslate.links"
                  :key="i.id"
                  :title="i.title"
                  :link="i.link"
                />
              </VueSlickCarousel>
            </div>
          </div>
        </div>
        <div
          class="container _pb-16"
          v-if="getAcademySection.children && getAcademySection.children.length"
        >
          <div class="sections__list d-grid row-1-1 gap-32 _mt-6">
            <SectionCard
              v-for="block in formattedAcademySection"
              :key="block.id"
              :item="block"
              @click.native="
                blockClick(
                  block.title,
                  helpers.buildRoute({
                    name: 'SuccessAcademySections',
                    params: {
                      slug: block.slug,
                      filtered: $route.params.filtered,
                    },
                  })
                )
              "
            >
              <template v-slot:image>
                <img :src="block.preview" alt="" />
              </template>
            </SectionCard>
          </div>
        </div>
      </div>
      <div class="d-flex justify-center _mt-6" v-else>
        <Preloader />
      </div>
      <OtherMain
        :items="others"
        v-if="
          getAcademyNeighbors &&
          getAcademyNeighbors.length &&
          formattedElements &&
          formattedElements.length &&
          others &&
          others.length
        "
        :analyticEventPrefix="'academy_'"
      >
        <template v-slot:title>
          <!-- eslint-disable vue/no-parsing-error -->
          <div
            class="section-detail__title _fs-32 _lh-38 _fs-sm-24 _lh-sm-32 _fw-600"
          >
            {{ $t("another_sections_title") }}
          </div>
        </template>
      </OtherMain>
    </section>
    <ErrorPage
      v-if="
        getAcademySection !== 404 &&
        getAcademySection !== null &&
        typeof getAcademySection !== 'object'
      "
      :code="`${getAcademySection}`"
    />
    <Choch v-else-if="getAcademySection === 404" />
  </div>
</template>

<script>
import Choch from "@/views/404";
import ErrorPage from "@/views/ErrorPage";
import TopBanner from "@/components/UI/banners/TopBanner";
import SectionCard from "@/components/UI/cards/SectionCard";
import AppBtnBreadCrumb from "@/components/UI/buttons/AppBtnBreadCrumb";
import MaterialCard from "@/components/UI/cards/MaterialCard";
import toPage from "@/mixins/toPage";
import download from "@/mixins/download";
import VideoCard from "@/components/UI/cards/VideoCard";
import OtherMain from "@/components/UI/OtherMain";
import Preloader from "@/components/UI/Preloader";
import { mapActions, mapGetters } from "vuex";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

export default {
  metaInfo() {
    if (this.currentTranslate && Object.keys(this.currentTranslate).length) {
      return { title: this.currentTranslate.title.replace(/<[^>]*>?/gm, "") };
    } else {
      return { title: this.$t("pages.success_academy.main_title") };
    }
  },
  name: "SuccessAcademySections",
  components: {
    Choch,
    ErrorPage,
    TopBanner,
    SectionCard,
    AppBtnBreadCrumb,
    VideoCard,
    OtherMain,
    MaterialCard,
    VueSlickCarousel,
    Preloader,
  },
  mixins: [toPage, download],
  data: () => ({
    targetElementId: null,
    countElements: 0,
    loadElements: 4,
    settings: {
      slidesToShow: 3,
      infinite: false,
      autoplay: false,
      arrows: false,
      draggable: false,
      responsive: [
        {
          breakpoint: 1220,
          settings: {
            slidesToShow: 1,
            infinite: false,
            variableWidth: true,
            draggable: true,
            arrows: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            infinite: false,
            variableWidth: true,
            draggable: true,
            arrows: false,
          },
        },
      ],
    },
  }),
  computed: {
    ...mapGetters(["getAcademySection", "getAcademyNeighbors"]),
    currentTranslate() {
      return this.getAcademySection?.translates?.[0];
    },
    currentLocale() {
      return this.Trans.currentLocale;
    },
    formattedElements() {
      if (!this.currentTranslate) {
        return null;
      }
      if (this.$route.params.filtered) {
        return this.currentTranslate.elements.filter((el) => !el.view).length
          ? this.currentTranslate.elements.filter((el) => !el.view)
          : this.currentTranslate.elements;
      }
      return this.currentTranslate.elements;
    },
    formattedAcademySection() {
      return this.getAcademySection.children.map(function (el) {
        return {
          ...el,
          title: el.title.replace(/[<]br[^>]*[>]/gi, " "),
        };
      });
    },
    banner() {
      if (!this.currentTranslate) {
        return null;
      }
      return {
        title: this.currentTranslate.title,
        theme: this.currentTranslate?.banners[0]?.theme,
        images: this.currentTranslate?.banners
          .map((el) => ({
            src: el.file || el.link,
            media: el.media,
          }))
          .sort(function (a, b) {
            if (parseInt(a.media) > parseInt(b.media)) {
              return 1;
            }
            if (parseInt(a.media) < parseInt(b.media)) {
              return -1;
            }
            return 0;
          }),
      };
    },
    others() {
      return this.getAcademyNeighbors.map(function (el) {
        return {
          title: el.title,
          image: el.section_preview,
          slug: el.slug,
          theme: el.theme || "dark",
        };
      });
    },
    showNav() {
      return this.currentTranslate.links.length > 4;
    },
  },
  methods: {
    ...mapActions([
      "fetchAcademySection",
      "fetchAcademyNeighbors",
      "academySetLike",
      "academySetFavorite",
      "academySetView",
      "academySetVideoProgress",
      "clearAcademyNeighbors",
    ]),
    blockClick(txt, path) {
      if (this.$gtm) {
        this.$gtm.push({
          event: "academy_block",
          param_value: this.helpers.stripHtml(txt),
        });
      }

      this.toPage(path);
    },
    showNext() {
      this.$refs.materialsCards.next();
    },
    showPrev() {
      this.$refs.materialsCards.prev();
    },
    loadMore() {
      if (
        this.countElements + this.loadElements <
        this.formattedElements.length - 1
      ) {
        this.countElements += this.loadElements;
      } else {
        this.countElements = this.formattedElements.length;
      }
    },
    async updateList() {
      await this.fetchAcademySection({
        lang: this.currentLocale,
        slug: this.getAcademySection.slug,
      });
    },

    async like(id) {
      await this.academySetLike(id);
      await this.updateList();
    },
    async favorite(id) {
      await this.academySetFavorite(id);
      await this.updateList();
    },
    async setVideoProgress(id, time) {
      await this.academySetVideoProgress({
        id: id,
        progress: Math.round(time),
      });
      await this.updateList();
    },
    async viewItem(id) {
      await this.academySetView(id);
      await this.updateList();
    },
    shouldShowHiddenElement() {
      const targetIndex = this.formattedElements.findIndex(
        el => el.id === this.targetElementId // Здесь, например, индекс элемента по ID
      );
      // Проверяем, скрыт ли элемент
      return targetIndex >= this.countElements;
    },
    autoLoadMore() {
      while (this.shouldShowHiddenElement()) {
        this.loadMore();
      }
    },
  },
  async mounted() {
    if (this.$route.params.slug) {
      await this.fetchAcademySection({
        lang: this.currentLocale,
        slug: this.$route.params.slug,
      });
      if (
        this.currentTranslate &&
        this.formattedElements &&
        this.formattedElements.length
      ) {
        await this.fetchAcademyNeighbors({
          slug: this.$route.params.slug,
          lang: this.currentLocale,
        });

        this.countElements =
          this.formattedElements.length < 4 ? this.formattedElements.length : 4;
      }
    }
  },
  beforeDestroy() {
    this.clearAcademyNeighbors();
  },
  created() {
    const hash = window.location.hash.slice(1);
    const match = hash.match(/intensive(\d+)/);
    const number = match ? parseInt(match[1], 10) : null;
    if (number !== null) {
      this.targetElementId = number; // Установим ID целевого элемента из хеша
    }
  },
  watch: {
    formattedElements() {
      if (this.targetElementId !== null && this.shouldShowHiddenElement()) {
        this.autoLoadMore();
      } 
    },
  },
};
</script>

<style lang="scss" scoped>
.row-1-1 {
  grid-template-columns: 1fr 1fr;

  @media screen and (max-width: 1220px) {
    grid-template-columns: 1fr;
  }
}

.gap-32 {
  grid-gap: 32px;
}

.other-carousel {
  width: 100%;
  max-width: calc(100vw - 32px);
  &__nav {
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
    align-items: center;
    @media screen and (max-width: 1220px) {
      display: none;
    }
    &-prev,
    &-next {
      cursor: pointer;
      &:hover svg rect {
        fill: #7f7f7c;
      }
    }
    &-prev svg rect,
    &-next svg rect {
      transition: 0.2s linear;
    }
  }
}

// .additional-links {
//   max-width: 100vw;
//   overflow-x: auto;
//   scroll-snap-type: x mandatory;
//   padding-bottom: 15px;
//   -ms-overflow-style: scrollbar;
//   scrollbar-color: #77bb2f transparent;
//   scrollbar-width: thin;

//   @media screen and (max-width: 1219px) {
//     -ms-overflow-style: scrollbar;
//     scrollbar-color: transparent;
//     scrollbar-width: thin;
//   }
//   @media screen and (min-width: 1220px) {
//     &::-webkit-scrollbar {
//       width: 5px;
//       height: 3px;
//       border-radius: 5px;
//     }

//     &::-webkit-scrollbar-thumb {
//       background-color: #77bb2f;
//       border-radius: 5px;
//       height: 3px;
//     }

//     &::-webkit-scrollbar--track-piece {
//       border-radius: 5px;
//       background-color: #ebefee;
//     }

//     &::-webkit-scrollbar-track {
//       border-radius: 5px;
//       background-color: #ebefee;
//       border: 3px solid color(light);
//     }

//     &::-moz-scrollbar-button:decrement,
//     &::-moz-scrollbar-button:increment,
//     &::-moz-scrollbar-button:vertical:start:decrement,
//     &::-moz-scrollbar-button:vertical:end:increment,
//     &::-moz-scrollbar-button:horizontal:start:decrement,
//     &::-moz-scrollbar-button:horizontal:end:increment,
//     &::-webkit-scrollbar-button:vertical:start:decrement,
//     &::-webkit-scrollbar-button:vertical:end:increment,
//     &::-webkit-scrollbar-button:horizontal:start:decrement,
//     &::-webkit-scrollbar-button:horizontal:end:increment {
//       width: 0px !important;
//       height: 0px !important;
//     }
//   }
// }
</style>
<style lang="scss">
.additional-links {
  width: 100%;
  max-width: 100vw;
  & .slick-list,
  & .slick-track {
    display: flex;
    align-items: stretch;
  }

  & .slick-slide {
    height: auto;

    & > * {
      height: 100%;
    }
  }
}
</style>
